import { Component, Input, OnInit } from '@angular/core';
import { StateCustomPanelVehicleService } from '../../service/state-custom-panel-vehicle.service';

@Component({
  selector: 'app-item-custom-panel-vehicle',
  templateUrl: './item-custom-panel-vehicle.component.html',
  styleUrls: ['./item-custom-panel-vehicle.component.scss'],
})
export class ItemCustomPanelVehicleComponent implements OnInit {
  @Input() idItem = 'default';
  @Input() statusInitial?: boolean;
  @Input() variant:
    | 'see'
    | 'color'
    | 'fixed'
    | 'icon'
    | 'imei'
    | 'numSim'
    | 'driver'
    | 'speed'
    | 'nameButton'
    | 'driverButton'
    | 'followUnitButton'
    | 'batteryVoltage'
    | 'amountOfFuel'
    | 'configurationButton'
    | 'transmissionStatus'
    | 'timeElapsed'
    | 'ignition'
    | 'satellite'
    | 'temperature-ble'
    | 'temperature-eye'
    | 'humidity-ble'
    | 'humidity-eye'
    | 'history'
    | 'command'
    | 'driverName'
    | 'eye' = 'configurationButton';

  @Input() labelInput: { on: string; off: string } = {
    on: 'activado',
    off: 'desactivado',
  };
  
  private servicePanel: StateCustomPanelVehicleService;
  public status = true; // marcado
  public showItem = true; // mostrar

  constructor(
    private _serviceCustomPanelVehicle: StateCustomPanelVehicleService
  ) {
    this.servicePanel = _serviceCustomPanelVehicle;
    if (this.statusInitial) {
      this.updateStatus(this.statusInitial);
    }
  }

  ngOnInit(): void {
    this.status = this.getStatusFromService();
    this.servicePanel.optionConfiguration$.subscribe((configuration)=>{
      let conf = configuration[this.idItem]
      if(!conf) return;
      this.status = conf.enabled
      this.showItem = conf.visible
    })
  }

  onCheckboxChange() {
    this.updateStatus(this.status);
  }

  private updateStatus(newStatus: boolean) {
    switch (this.variant) {
      case 'see':
        this.servicePanel.setShowCheckbox(newStatus);
        break;
      case 'numSim':
        this.servicePanel.setShowNumSim(newStatus);
        break;
      case 'color':
        this.servicePanel.setShowColorStatus(newStatus);
        break;
      case 'fixed':
        this.servicePanel.setShowFixedCollection(newStatus);
        break;
      case 'icon':
        this.servicePanel.setShowIconVehicle(newStatus);
        break;
      case 'imei':
        this.servicePanel.setShowImei(newStatus);
        break;
      case 'driver':
        this.servicePanel.setShowDriverButton(newStatus);
        break;
      case 'nameButton':
        this.servicePanel.setShowNameButton(newStatus);
        break;
      case 'followUnitButton':
        this.servicePanel.setShowFollowUnitButton(newStatus);
        break;
      case 'speed':
        this.servicePanel.setShowSpeed(newStatus);
        break;
      case 'configurationButton':
        this.servicePanel.setShowConfigurationButton(newStatus);
        break;
      case 'batteryVoltage':
        this.servicePanel.setShowBatteryVoltage(newStatus);
        break;
      case 'amountOfFuel':
        this.servicePanel.setShowAmountOfFuel(newStatus);
        break;
      case 'transmissionStatus':
        this.servicePanel.setShowTransmissionStatus(newStatus);
        break;
      case 'timeElapsed':
        this.servicePanel.setShowTimeElapsed(newStatus);
        break;
      case 'ignition':
        this.servicePanel.setShowIgnitionStatus(newStatus);
        break;
      case 'satellite':
        this.servicePanel.setShowSatelliteCount(newStatus);
        break;
      case 'eye':
        this.servicePanel.setShowEyeButton(newStatus);
        break;
      case 'temperature-ble':
        this.servicePanel.setShowTemperatureBle(newStatus);
        break;
      case 'temperature-eye':
        this.servicePanel.setShowTemperatureEye(newStatus);
        break;
      case 'humidity-ble':
        this.servicePanel.setShowHumidityBle(newStatus);
        break;
      case 'humidity-eye':
        this.servicePanel.setShowHumidityEye(newStatus);
        break;
      case 'history':
        this.servicePanel.setShowHistoryButton(newStatus);
        break;
      case 'command':
        this.servicePanel.setShowCommandButton(newStatus);
        break;
      case 'driverName':
        this.servicePanel.setShowNameDriver(newStatus);
        break;
      default:
        console.log('Revisar los valores proporcionados en variant');
    }
  }

  private getStatusFromService(): boolean {
    switch (this.variant) {
      case 'see':
        return this.servicePanel.getShowCheckbox();
      case 'color':
        return this.servicePanel.getShowColorStatus();
      case 'fixed':
        return this.servicePanel.getShowFixedCollection();
      case 'icon':
        return this.servicePanel.getShowIconVehicle();
      case 'imei':
        return this.servicePanel.getShowImei();
      case 'numSim':
        return this.servicePanel.getShowNumSim();
      case 'driver':
        return this.servicePanel.getShowDriverButton();
      case 'nameButton':
        return this.servicePanel.getShowNameButton();
      case 'followUnitButton':
        return this.servicePanel.getShowFollowUnitButton();
      case 'speed':
        return this.servicePanel.getShowSpeed();
      case 'configurationButton':
        return this.servicePanel.getShowConfigurationButton();
      case 'batteryVoltage':
        return this.servicePanel.getShowBatteryVoltage();
      case 'amountOfFuel':
        return this.servicePanel.getShowAmountOfFuel();
      case 'transmissionStatus':
        return this.servicePanel.getShowTransmissionStatus();
      case 'timeElapsed':
        return this.servicePanel.getShowTimeElapsed();
      case 'ignition':
        return this.servicePanel.getShowIgnitionStatus();
      case 'satellite':
        return this.servicePanel.getShowSatelliteCount();
      case 'eye':
        return this.servicePanel.getShowEyeButton();
      case 'temperature-ble':
        return this.servicePanel.getShowTemperatureBle();
      case 'temperature-eye':
        return this.servicePanel.getShowTemperatureEye();
      case 'humidity-ble':
        return this.servicePanel.getShowHumidityBle();
      case 'humidity-eye':
        return this.servicePanel.getShowHumidityEye();
      case 'history':
        return this.servicePanel.getShowHistoryButton();
      case 'command':
        return this.servicePanel.getShowCommandButton();
      case 'driverName':
        return this.servicePanel.getShowNameDriver();
      default:
        console.log('Revisar los valores proporcionados en variant');
        return false; // Valor por defecto si no coincide con ningún caso
    }
  }
}
